import { SelectItem } from 'app/shared/models/select-item.type';
import {
	VehicleOdometerChangeReasonEnum,
	VehicleRoadWorthyCheckRecordCategoryEnum,
	VehicleRoadWorthyCheckStatusEnum,
	vehicleRoadWorthyCheckStatusToColor,
} from '@splitsecondconnect/ultramarine-shared';

import { FEATURES } from '../../../../core/features/features';

export const VEHICLE_ROAD_WORTHY_CHECK_STATUSES: SelectItem<VehicleRoadWorthyCheckStatusEnum>[] =
	[
		{
			value: VehicleRoadWorthyCheckStatusEnum.ACTIVE,
			displayValue: 'road-worthy-checks|status|active',
			pillColor: vehicleRoadWorthyCheckStatusToColor(
				VehicleRoadWorthyCheckStatusEnum.ACTIVE,
			),
		},
		{
			value: VehicleRoadWorthyCheckStatusEnum.PENDING,
			displayValue: 'road-worthy-checks|status|pending',
			pillColor: vehicleRoadWorthyCheckStatusToColor(
				VehicleRoadWorthyCheckStatusEnum.PENDING,
			),
		},
		// {
		// 	value: VehicleRoadWorthyCheckStatusEnum.APPROVED,
		// 	displayValue: 'road-worthy-checks|status|approved',
		// 	pillColor: vehicleRoadWorthyCheckStatusToColor(
		// 		VehicleRoadWorthyCheckStatusEnum.APPROVED,
		// 	),
		// },
		// {
		// 	value: VehicleRoadWorthyCheckStatusEnum.REJECTED,
		// 	displayValue: 'road-worthy-checks|status|rejected',
		// 	pillColor: vehicleRoadWorthyCheckStatusToColor(
		// 		VehicleRoadWorthyCheckStatusEnum.REJECTED,
		// 	),
		// },
		// {
		// 	value: VehicleRoadWorthyCheckStatusEnum.IN_PROGRESS,
		// 	displayValue: 'road-worthy-checks|status|in-progress',
		// 	pillColor: vehicleRoadWorthyCheckStatusToColor(
		// 		VehicleRoadWorthyCheckStatusEnum.IN_PROGRESS,
		// 	),
		// },
		{
			value: VehicleRoadWorthyCheckStatusEnum.EXPIRED,
			displayValue: 'road-worthy-checks|status|expired',
			pillColor: vehicleRoadWorthyCheckStatusToColor(
				VehicleRoadWorthyCheckStatusEnum.EXPIRED,
			),
		},
	];
export const VEHICLE_ROAD_WORTHY_CHECK_RECORD_CATEGORIES: SelectItem<VehicleRoadWorthyCheckRecordCategoryEnum>[] =
	[
		{
			value: VehicleRoadWorthyCheckRecordCategoryEnum.VEHICLE,
			displayValue: 'road-worthy-checks|record-category|vehicle',
			disabled: !FEATURES.vehicles,
		},
	];

export const VEHICLE_ODOMETER_VALUE_CHANGE_REASON: SelectItem<VehicleOdometerChangeReasonEnum>[] =
	[
		{
			value: VehicleOdometerChangeReasonEnum.INITIAL,
			displayValue: 'vehicles|task|update-odometer|reason|initial',
		},
		{
			value: VehicleOdometerChangeReasonEnum.TRANSFER,
			displayValue: 'vehicles|task|update-odometer|reason|transfer',
		},
		{
			value: VehicleOdometerChangeReasonEnum.CORRECTION,
			displayValue: 'vehicles|task|update-odometer|reason|correction',
		},
		{
			value: VehicleOdometerChangeReasonEnum.CHECK_IN,
			displayValue: 'vehicles|task|update-odometer|reason|check-in',
		},
		{
			value: VehicleOdometerChangeReasonEnum.CHECK_OUT,
			displayValue: 'vehicles|task|update-odometer|reason|check-out',
		},
		{
			value: VehicleOdometerChangeReasonEnum.TRACKER_READING,
			displayValue: 'vehicles|task|update-odometer|reason|tracker-reading',
		},
	];
